import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import { ArrowClockwiseIcon } from "@phosphor-icons/react";
import { type ReactNode, useEffect, useTransition } from "react";
import { useRouter } from "@/app/navigation";
import { Button } from "@/components/ui/button";
import { BaseToolbar } from "@/components/workspace/toolbar";
export function CollectionRefresh({
  active,
  showToolbar = false,
  children,
}: {
  active: boolean;
  showToolbar?: boolean;
  children?: ReactNode;
}) {
  const router = useRouter();
  const [refreshing, startRefresh] = useTransition();
  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") router.refresh();
    }, 5000);
    return () => clearInterval(timer);
  }, [active, router]);
  return showToolbar ? (
    <BaseToolbar
      leadingActions={children}
      trailingActions={
        <Button
          label="Refresh"
          ariaLabel="Refresh runs"
          icon={ArrowClockwiseIcon}
          variant={ButtonVariant.SECONDARY}
          isLoading={refreshing}
          isDisabled={refreshing}
          onClick={() => startRefresh(() => router.refresh())}
          size={ButtonSize.SMALL}
          tooltip="Refresh runs"
        />
      }
    />
  ) : null;
}
